import { render } from "./full_oncology_head.vue?vue&type=template&id=1f89881e&scoped=true"
import script from "./full_oncology_head.vue?vue&type=script&lang=js"
export * from "./full_oncology_head.vue?vue&type=script&lang=js"

import "./full_oncology_head.vue?vue&type=style&index=0&id=1f89881e&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f89881e"]])

export default __exports__